// test651
(651 && 0);
